
<div class="row">
    <div class="col" *ngIf="componentType == ComponentType.farmApp || componentType == ComponentType.deployment || componentType == ComponentType.engagement
    || componentType == ComponentType.conversation">
        <div class="btn-group" role="group">
            <button type="button" class="btn-1 first" (click)="setOperationType(OperationType.Qualification)" 
            [ngClass]="{'active':operationType == OperationType.Qualification}">
                Qualification
            </button>
            <button type="button" class="btn-1 second center-btn" (click)="setOperationType(OperationType.Deployment)" 
            [ngClass]="{'active':operationType == OperationType.Deployment}">
                Deployment
            </button>
            <button type="button" class="btn-1 center-btn" (click)="setOperationType(OperationType.Engagement)"
            [ngClass]="{'active':operationType == OperationType.Engagement}" style="border-left: 1.5px solid #009ee6 !important;">
                Engagement
            </button>
            <button type="button" class="btn-1 second" (click)="setOperationType(OperationType.Conversation)"
            [ngClass]="{'active':operationType == OperationType.Conversation}">
                Conversation
            </button>
        </div>
    </div>
    <div class="col" *ngIf="componentType == ComponentType.warehouseApp || componentType == ComponentType.qualityCheck 
    || componentType == ComponentType.warehouseDashboard">
        <div class="btn-group" role="group">
            <button type="button" class="btn-1 first" (click)="setWarehouseType(WarehouseType.Dashboard)"
            [ngClass]="{'active':warehouseType == WarehouseType.Dashboard}">
                Dashboard
            </button>
            <button type="button" class="btn-1 second center-btn"(click)="setWarehouseType(WarehouseType.Warehouse)" 
            [ngClass]="{'active':warehouseType == WarehouseType.Warehouse}">
                Warehouse
            </button>
            <button type="button" class="btn-1 second" (click)="setWarehouseType(WarehouseType.QualityCheck)" 
            [ngClass]="{'active':warehouseType == WarehouseType.QualityCheck}" style="width: max-content;">
                Quality check
            </button>
        </div>
    </div>
    <div class="col" *ngIf="componentType == ComponentType.hseDashboard || componentType == ComponentType.hseReport">
        <div class="btn-group" role="group">
            <button type="button" class="btn-1 first" (click)="setHseType(HseType.Dashboard)" 
            [ngClass]="{'active':hseType == HseType.Dashboard,
            'first':hasHseSummaryAccess && hasHseReportAccess}" *ngIf="hasHseSummaryAccess">
                Dashboard
            </button>
            <button type="button" class="btn-1 second" (click)="setHseType(HseType.Report)" 
            [ngClass]="{'active':hseType == HseType.Report,
            'second':hasHseSummaryAccess && hasHseReportAccess}" style="width: max-content;" *ngIf="hasHseReportAccess">
                Reported
            </button>
        </div>
    </div>
    <div class="col" *ngIf="componentType == ComponentType.summary || componentType == ComponentType.samples || componentType == ComponentType.carts 
    || componentType == ComponentType.shipments">
        <div class="btn-group" role="group">
            <button type="button" class="btn-1 first" (click)="setLabOperationType(LabOperationType.Summary)" 
            [ngClass]="{'active':labOperationType == LabOperationType.Summary}">
                Summary
            </button>
            <button type="button" class="btn-1 second center-btn" (click)="setLabOperationType(LabOperationType.Samples)" 
            [ngClass]="{'active':labOperationType == LabOperationType.Samples}"
            style="border-right: 1.5px solid #009FF6 !important;">
                Samples
            </button>
            <button type="button" class="btn-1 second center-btn" (click)="setLabOperationType(LabOperationType.Carts)"
            [ngClass]="{'active':labOperationType == LabOperationType.Carts}">
                Carts
            </button>
            <button type="button" class="btn-1 second" (click)="setLabOperationType(LabOperationType.Shipments)"
            [ngClass]="{'active':labOperationType == LabOperationType.Shipments}">
                Shipments
            </button>
        </div>
    </div>
    <div class="col"  *ngIf="componentType == ComponentType.dashboard || componentType == ComponentType.summaryDashboard">
        <div class="header">
            Dashboard
        </div>
    </div>
    <div class="col" *ngIf="componentType == ComponentType.supplyDemand || componentType == ComponentType.Planning">
        <div class="btn-group" role="group">
            <button type="button" class="btn-1 first" (click)="setSupplyDemand('PlanVsActual')" 
            [ngClass]="{'active':supplyDemandType == 'PlanVsActual'}" style="width: max-content;">
                Plan vs Actual
            </button>
            <button type="button" class="btn-1 second " (click)="setSupplyDemand('SupplyDemand')" 
            [ngClass]="{'active':supplyDemandType == 'SupplyDemand'}" style="width: max-content;">
                Supply Demand
            </button>
        </div>
    </div>
    <div class="col" *ngIf="componentType == ComponentType.qualityCheckNew || componentType == ComponentType.qualityDefect || componentType == ComponentType.qualitySource">
        <div class="btn-group" role="group">
            <button type="button" class="btn-1 first" (click)="setQualityCheckType(QualityCheckNewType.Dashboard)" 
            [ngClass]="{'active':qualityType == QualityCheckNewType.Dashboard}" style="width: max-content;">
                Dashboard
            </button>
            <button type="button" class="btn-1 second" (click)="setQualityCheckType(QualityCheckNewType.Defects)"
            [ngClass]="{'active':qualityType == QualityCheckNewType.Defects}">
                Defects
            </button>
            <!-- center-btn -->
            <!-- <button type="button" class="btn-1 second " (click)="setQualityCheckType(QualityCheckNewType.Sources)" 
            [ngClass]="{'active':qualityType == QualityCheckNewType.Sources}" style="width: max-content;">
                Sources
            </button> -->
        </div>
    </div>
    <div class="col-auto" style="width:200px">
        <div class="user-details">
            <div class="row">
                <div class="col-auto p-0 content-center" style="width:40px">
                    <div class="img-circle">
                        <img src="../../../../assets/images/user-icon.svg" alt="user-icon" width="24px" height="24px">
                    </div>
                </div>
                <div class="col ml-auto p-0 pl-8">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 p-0 username">
                                Hello, {{username|titlecase}}
                            </div>
                            <div class="col-12 p-0">
                                <!-- <button class="btn-1 btn-no-border" (click)="onLogout()">Logout</button> -->
                                <div class="dropdown">
                                    <button class="btn-1 btn-no-border"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="switchProfileBtn">{{selectedProfile}}</button>
                                    
                                    <div class="dropdown-menu" aria-labelledby="switchProfileBtn">
                                        <button class="dropdown-item" (click)="onSwitchProfile('Admin')">Admin</button>
                                        <button class="dropdown-item" (click)="onSwitchProfile('Verifier')">Verifier</button>
                                        <button class="dropdown-item" (click)="onLogout()">Logout</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>   